import { memo } from "react";
import { Text } from "../../text";

export const SegmentBuilderText = memo(function SegmentBuilderText({
  children,
}: {
  children: string;
}) {
  return (
    <Text
      fontSize="xs"
      fontWeight="medium"
      textColor="primary"
      whiteSpace="break-spaces"
    >
      {children}
    </Text>
  );
});
